import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { clsx } from "clsx";
import { Button } from "components/common/Button";

interface AddRouteButtonProps {
  onClick: () => void;
  className?: string;
}

export const AddRouteButton = ({ onClick, className }: AddRouteButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="primary"
      size="sm"
      onClick={onClick}
      startAdornment={<Plus className="w-3.5 h-3.5" />}
      className={clsx("shrink-0", className)}
    >
      {t("smartSurveyor.routesCreation.addRoute")}
    </Button>
  );
};
